/** The router's search codec: `URLSearchParams` keeps email links and bookmarks working; TanStack's JSON would not. */
// `stringifySearch` writes `String(value)`, which `searchParam`'s typed values read back from.

/**
 * For a query string other than the current URL's, such as one inside a stored link; the leading `?` is optional.
 * Read the current URL's params with `useSearch` or `getRouteApi(id).useSearch`, which validate and type them. In the
 * app, lint allows those only where the import fence in documentation/routing-reference.md lists them.
 */
export function parseSearch(searchStr: string): Record<string, string> {
    const result: Record<string, string> = {};
    for (const [key, value] of new URLSearchParams(searchStr)) {
        result[key] = value;
    }
    return result;
}

/**
 * `?key=value`, or `''` when empty. For a query string as text, such as the one an app slot matches against
 * (`useSearch({ strict: false, select: stringifySearch })`); a link or `setSearch` takes the record itself.
 */
export function stringifySearch(search: Record<string, unknown>): string {
    const searchParams = new URLSearchParams();
    for (const [key, value] of Object.entries(search)) {
        if (value !== null && value !== undefined) {
            searchParams.set(key, value + '');
        }
    }
    const str = searchParams.toString();
    return str === '' ? '' : `?${str}`;
}
